function GetCurrency(value) {
    return currencyFormat(value, "c");
}

function getCurrencyWithoutDecimalPlaces(value) {
    return currencyFormat(value, "c0");
}

function currencyFormat(value, format) {
    if (!kendo.cultures[userSettings.currentCurrencyCode]) {
        userSettings.currentCurrencyCode = "de-DE";
    }
    kendo.culture(userSettings.currentCurrencyCode);
    var result = kendo.toString(value * userSettings.currentCurrencyMultiplicator, format);
    kendo.culture(userSettings.currentCulture);
    return result;
}
